import { render, staticRenderFns } from "./PerformanceIndicators.vue?vue&type=template&id=0214701a&scoped=true"
import script from "./PerformanceIndicators.vue?vue&type=script&lang=js"
export * from "./PerformanceIndicators.vue?vue&type=script&lang=js"
import style0 from "./PerformanceIndicators.vue?vue&type=style&index=0&id=0214701a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214701a",
  null
  
)

export default component.exports